import React from 'react';

export default class Header extends React.Component {

  render() {
    return (
      <div className="header">
      <i className="icon-logo pf-logo" />
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/components/common/header.js